<template>
  <div class="root">
    <div class="week" v-for="(week, i) in days" v-if="week.length" :key="i">
      <div class="day" v-for="cell in week" :key="cell.date.getDate()">
        <day-cell :id="cell.id" :day="cell.date" :is-today="cell.date.valueOf() === today.valueOf()" :color="cell.color"
                  :avvisi="computedAvvisi[$utils.date.toSql(cell.date)]"
                  @click="$emit('click:cell', cell.id, cell.date, computedAvvisi[$utils.date.toSql(cell.date)])"/>
      </div>
    </div>
  </div>

</template>

<script>
import DayCell from './DayCell'

export default {
    name: 'DayCellTable',
    components: { DayCell },
    props: {
        month: Number,
        year: Number,
        avvisi: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        days () {
            return this.getDaysList(this.year, this.month)
        },
        today () {
            let today = new Date()
            today.setHours(0, 0, 0, 0)
            return today
        },
        computedAvvisi () {
            let res = {}
            this.avvisi.map(avviso => {
                if (!res[avviso.data_avviso]) {
                    res[avviso.data_avviso] = []
                }
                res[avviso.data_avviso].push(avviso)
            })
            return res
        }
    },
    memoizedDays: {},
    methods: {
        getDaysList (year, month) {
            month = month - 1 //  I mesi in JS vanno da 0 a 11
            let days = [[]]
            if (this.$options.memoizedDays[year + '-' + month]) {
                days = this.$options.memoizedDays[year + '-' + month]
            } else {
                let date = new Date(year, month, 1)
                let weekDay = date.getDay() || 7 //  Domenica diventa il numero 7, così i giorni partono da lunedì

                date.setDate(date.getDate() - (weekDay - 1)) //  La lista inizia dal primo lunedì

                let monthBefore = date.getMonth()
                while (date.getMonth() === monthBefore || date.getMonth() === month || date.getDay() !== 1) {
                    //  Inserisce nell'array una copia dalla data
                    days[days.length - 1].push({
                        id: 'id' + date.getTime(),
                        date: new Date(date),
                        color: (date.getMonth() !== month) ? '#f5f5f5 ' : 'white'
                    })
                    //  Se ho completato una settimana, se ne crea un'altra
                    if (days[days.length - 1].length >= 7) {
                        days.push([])
                    }
                    date.setDate(date.getDate() + 1)
                }
                this.$options.memoizedDays[year + '-' + month] = days
            }
            let fromDate = this.$utils.date.toSql(days[0][0].date)
            let toDate = this.$utils.date.toSql(days[days.length - 2][days[days.length - 2].length - 1].date)
            this.$emit('update-view', fromDate, toDate)
            return days
        }
    }
}
</script>

<style scoped lang="scss">
  .root {
    //table-layout: fixed;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .week {
      display: flex;
      flex: 1;

      .day {
        display: flex;
        flex: 1;
        margin-bottom: 1px;
        max-width: calc(100% / 7);
      }
    }
  }

</style>
